import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import NotificacoesCard from './components/NotificacoesCard';

const NotificacoesMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Notificações'
        }]} />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <NotificacoesCard />
        </Col>
      </Row>
    </Container>;
};

export default NotificacoesMain;
